module.exports = __webpack_public_path__ + "img/supermercados.9094d974.png";